import h from 'react-hyperscript';
import './Banner.scss';

const Banner = (props) => {
  return (
    h('div', {
      key: `banner__key`,
      className: 'banner',
    }, [h('p', {
      key: `banner__p__key`,
      className: 'container banner__text',
    }, props.message)] )
  );
};

export default Banner;
